import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {Observable} from 'rxjs';
import {Pledge} from '../../../../services/api.client';
import {PledgeService} from '../../../../services/PledgeService';
import {ITableHeader, TableComponent} from '../../../shared/table/TableComponent';
import {User} from '../../../../services/api.client';
import {FormControl, FormGroup, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {startOf, nowDate} from '../../../../utilities/date-util';
import {PledgeType} from '../../../../services/api.client';
import {SecurityService} from '../../../../services/SecurityService';

@Component({
    selector: 'manualPendingToPaid',
    templateUrl: './ManualPendingToPaidComponent.html',
    styleUrls: ['./ManualPendingToPaidComponent.scss'],
    standalone: false
})

export class ManualPendingToPaidComponent implements OnInit, AfterViewInit {

    get paidDate(): FormControl {
        return this.form.get('paidDate') as FormControl;
    }

    get pledgeIds(): FormControl {
        return this.form.get('pledgeIds') as FormControl;
    }

    form = new FormGroup({
        paidDate: new FormControl(startOf(nowDate(), 'year')),
        pledgeIds: new FormControl([])
    });

    tableHeaders: ITableHeader[] = [];

    // subscriptions
    isLoading: boolean;
    isLoading$: Observable<boolean>;
    currentUser: User;
    currentUser$: Observable<User>;
    pledges: Pledge[];
    pledges$: Observable<Pledge[]>;
    pledgeTypes: PledgeType[];
    pledgeTypes$: Observable<PledgeType[]>;

    @ViewChild(TableComponent)
    table: TableComponent;

    constructor(public _pledgeService: PledgeService,
                private _formBuilder: UntypedFormBuilder,
                private _securityService: SecurityService) {
        this.currentUser$ = this._securityService.currentUser$;
        this.isLoading$ = this._pledgeService.isPledgesLoading$;
        this.pledges$ = this._pledgeService.manualPendingPledges$;
        this.pledgeTypes$ = this._securityService.pledgeTypes$;
    }

    ngOnInit(): void {
        this.currentUser$.subscribe(currentUser => this.currentUser = currentUser);
        this.isLoading$.subscribe(isLoading => this.isLoading = isLoading);
        this.pledges$.subscribe(pledges => this.pledges = pledges);
        this.pledgeTypes$.subscribe(pledgeTypes => this.pledgeTypes = pledgeTypes);
        this._pledgeService.getManualPendingToPaidPledges();
        this.initForm();
        if (this.currentUser.hasPrivate) {
            this.tableHeaders = [
                {text: 'Select to Pay', },
                {text: 'Last Name', sortKey: 'ClientLastName'},
                {text: 'First Name', sortKey: 'ClientFirstName'},
                {text: 'SSN.', sortKey: 'ClientLast4Ssn'},
                {text: 'Pledge', sortKey: 'PledgedAmount'},
                {text: 'Fund Type', sortKey: 'Name'},
                {text: 'Date', sortKey: 'PledgedDate'},
                {text: 'Status', sortKey: 'Status'},
                {text: 'Ledger #'},
                {text: 'Private'},
            ];
        } else {
            this.tableHeaders = [
                {text: 'Select to Pay', },
                {text: 'Last Name', sortKey: 'ClientLastName'},
                {text: 'First Name', sortKey: 'ClientFirstName'},
                {text: 'SSN.', sortKey: 'ClientLast4Ssn'},
                {text: 'Pledge', sortKey: 'PledgedAmount'},
                {text: 'Fund Type', sortKey: 'Name'},
                {text: 'Date', sortKey: 'PledgedDate', ascending: true},
                {text: 'Status', sortKey: 'Status'},
                {text: 'Ledger #', },
            ];
        }
    }

    initForm(): void {
        this.form = this._formBuilder.group({
            paidDate: [startOf(nowDate(), 'year')],
            pledgeIds: [],
        });
    }

    ngAfterViewInit(): void {
    }

    formatFundType(fundTypeId): string {
        if (this.pledgeTypes) {
            for (const pledgeType of this.pledgeTypes) {
                if (pledgeType.id === fundTypeId) {
                    return pledgeType.name;
                }
            }
            return 'Missing Pledge Type';
        }
    }

    submit(): any {
        return void 0;
    }

    manualSubmitPendingToPaid(): void {
        const form = this.form.value;
        this._pledgeService.bulkUpdateManualPendingToPaid(form);
    }

    ngOnDestroy(): void {
        this._pledgeService.clearManualPendingPledges();
    }

    // TODO: disable Pay button if no selection or no date
}
